import EntrepreneurshipsAssignedEvaluator from '@/pages/evaluator/EntrepreneurshipsAssigned.vue'
import EntrepreneurshipTasksEvaluator from '@/pages/evaluator/EntrepreneurshipTasks.vue'
import EntrepreneurshipTasksModuleEvaluator from '@/pages/evaluator/EntrepreneurshipTasksModule.vue'

import showStartUpEvaluator from '@/pages/evaluator/show/showStartUp.vue'
import showStartUpTeamEvaluator from '@/pages/evaluator/show/showTeam.vue'
import showStartupWindowEvaluator from '@/pages/evaluator/show/showWindow.vue'

import ModulesPreIncubation from '@/pages/evaluator/modules/ModulesPreIncubation.vue'
import ModulePreIncubation from '@/pages/evaluator/modules/ModulePreIncubation.vue'

const evaluatorRoutes = [
  {
    path: '/evaluator/entrepreneurships-assigned',
    name: 'EntrepreneurshipsAssignedEvaluator',
    component: EntrepreneurshipsAssignedEvaluator,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados'
        }
      ]
    }
  },
  {
    path: '/evaluator/entrepreneurships-assigned/:slug',
    name: 'EntrepreneurshipTasksEvaluator',
    component: EntrepreneurshipTasksEvaluator,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedEvaluator'}
        },
        {
          text: 'Tareas'
        }
      ]
    }
  },
  {
    path: '/evaluator/entrepreneurships-assigned/:slug/module/:module_pre_incubation_id/tasks',
    name: 'entrepreneurshipTasksModuleEvaluator',
    component: EntrepreneurshipTasksModuleEvaluator,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedEvaluator'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksEvaluator'}
        },
        {
          text: 'Ver',
        }
      ]
    }
  },
  {
    path: '/evaluator/entrepreneurships-assigned/:slug/startup',
    name: 'showStartUpEvaluator',
    component: showStartUpEvaluator,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedEvaluator'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksEvaluator'}
        },
        {
          text: 'Ver StartUp',
        }
      ]
    }
  },
  {
    path: '/evaluator/entrepreneurships-assigned/:slug/team',
    name: 'showStartUpTeamEvaluator',
    component: showStartUpTeamEvaluator,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedEvaluator'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksEvaluator'}
        },
        {
          text: 'Ver equipo',
        }
      ]
    }
  },
  {
    path: '/evaluator/entrepreneurships-assigned/:slug/window',
    name: 'showStartupWindowEvaluator',
    component: showStartupWindowEvaluator,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Emprendimientos asignados',
          to: { name: 'EntrepreneurshipsAssignedEvaluator'}
        },
        {
          text: 'Tareas',
          to: { name: 'EntrepreneurshipTasksEvaluator'}
        },
        {
          text: 'Ver vidriera',
        }
      ]
    }
  },
  {
    path: '/evaluator/modules',
    name: 'ModulesPreIncubation',
    component: ModulesPreIncubation,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Modúlos'
        }
      ]
    }
  },
  {
    path: '/evaluator/modules/:slug',
    name: 'ModulePreIncubation',
    component: ModulePreIncubation,
    meta: {
      auth: true,
      role: 'evaluator',
      breadCrumb: [
        {
          text: 'Modúlos',
          to: { name: 'ModulesPreIncubation'}
        },
        {
          text: 'ver modúlos'
        }
      ]
    }
  },

]

export default evaluatorRoutes